//------------------------------------------------------------------------
// Custom selects
//
// Allows for styling with CSS by making the original select transparent and
// adding a placeholder div whose text updates when the select is changed.
//
// • Any custom classes will be moved to the parent div
// • Inline min-width will be set on the wrapper based on the longest <option>…
// • …unless the select is set to “display: block” or has “is-full-width” class
// • You can still disable the select using the “disabled” attribute like normal
//
// <select class="js-custom-select">…</select>
//------------------------------------------------------------------------
'use strict';
import Backbone from 'backbone';
import $ from 'jquery';

var CustomSelect = Backbone.View.extend({
  events: {
    'change': 'update'
  },

  initialize: function( data ) {
    var self = this;

    // Check if select should be full width
    this.isBlock = this.$el.css('display') === 'block' || this.$el.hasClass('is-full-width');

    // Get classes from select element
    this.classes = this.$el.attr('class') || '';

    // Create copy of select element
    this.$select = this.$el.clone().attr('class', 'CustomSelect-select');

    // Create placeholder div, will be styled to look like the custom select
    this.$placeholder = $('<div>', {
      'aria-hidden': true,
      'class': 'CustomSelect-placeholder'
    });

    // Create wrapper for select and placeholder text elements
    // then add select and placeholder text elements
    this.$wrapper = $('<div>', {
      'class': 'CustomSelect ' + this.classes
    });

    // Add select and placeholder elements to wrapper
    this.$wrapper.append(this.$select, this.$placeholder);

    // Replace original select with wrapper markup
    this.$el.replaceWith(this.$wrapper);

    // We need to reset the Backbone view element to the <select> element since we changed the markup
    this.setElement(this.$select)

    // Set min-width to fit longest <option> text
    if ( !this.isBlock ) {
      this.setMinWidth();
    }

    // Update text with the currently selected option
    this.update();

    // Display custom select
    this.$wrapper.addClass('js-init');

    // // Update min-width after stylesheets have loaded
    // document.documentElement.addEventListener('css-loaded', function() {
    //   self.setMinWidth();
    // }, false);

    // // Update min-width after webfonts have loaded
    // document.documentElement.addEventListener('fonts-loaded', function() {
    //   self.setMinWidth();
    // }, false);
  },

  // Update placeholder with currently select text
  update: function() {
    var $selected = this.$('option:selected');
    var isPlaceholder = this.$placeholder.text( this.$('option:selected').text() );
  },

  // Get
  setMinWidth: function() {
    var optText = [];

    this.$('option').each( function() {
      optText.push( $(this).text() );
    });

    // Get longest text
    var longestText = optText.sort(function (a, b) { return b.length - a.length; })[0];

    // Update custom select with longest text
    this.$placeholder.text( longestText );

    // Set inline min-width to prevent text from being truncated
    this.$wrapper.css('min-width', this.$placeholder.outerWidth() + 1 + 'px');// 1px required for IE10
  }
});

// Init
$('select.js-custom-select').each( function() {
  var select = new CustomSelect({ el: this });
});

// return access to the constructor
export default CustomSelect;